import { ERROR_CALLBACK_TYPES } from 'in-meeting-experience-ui-components/constants/errors';
import { getHostApiUrl } from 'in-meeting-experience-ui-components/utils/general';
import noAuthClient from '../../utils/apiClient';
const API_BASE_V2 = `${getHostApiUrl()}/embedded-view-auth/connected-accounts`;
export const fetchUserAccountsV2 = () => noAuthClient.get(`${API_BASE_V2}`, {
  errorCallback: ERROR_CALLBACK_TYPES.authentication
});